import Departments from '../components/Department'

const Department = () => {
  return (
    <>
    <Departments />
    </>
  )
}

export default Department